<template>
	<div>

		<div>
			<v-row>
				<v-col md="3" class="pt-0">
					<v-card class="d-flex flex-row mb-6" flat >
						<v-card  flat >
							<img src="@/assets/order.svg" alt="img"  width="25px" class="mt-3 mr-1">
						</v-card>
						<v-card  flat >
							<p class="filter-sub-title">{{$lang.TRANSACTION_ID}}</p>
							<p class="sub-title-text">{{transaction_id}}</p>
						</v-card>
					</v-card>
				</v-col>
			<!-- 	<v-col md="3" class="pt-0">
					<v-card class="d-flex flex-row mb-6 pt-0" flat >
						<v-card   flat >
							<img src="@/assets/drawer/shipment-active.svg" alt="img"  width="25px" class="mt-3 mr-1">
						</v-card>
						<v-card class="pa-2" flat >
							<p class="filter-sub-title">{{$lang.PACKAGES}}</p>
							<p class="sub-title-text">{{trip_details.total_package}}</p>
						</v-card>
					</v-card>
				</v-col> -->
				<v-col md="3" class="pt-0">
					<v-card class="d-flex flex-row mb-6 pt-0" flat >
						<v-card   flat >
							<img src="@/assets/calender.svg" alt="img"  width="25px" class="mt-3 mr-1">
						</v-card>
						<v-card class="pa-2" flat >
							<p class="filter-sub-title">{{$lang.DATE}}</p>
							<p class="sub-title-text">{{trip_details.deposit_created}}</p>
						</v-card>
					</v-card>
				</v-col>
			</v-row>
			<v-row>
				<v-col md="3" class="pt-0">
					<p class="sub-title-text-dark">{{$lang.DELIVERY_AGENT_DETAILS}}</p>
					<p class="sub-title-text-dark secondary-text fs-13">{{trip_details.delivery_agent_name}}</p>
					<p class="sub-title-text-dark secondary-text fs-13">{{$lang.MOBILE_PREFIX}}{{trip_details.delivery_agent_mobile_number}}</p>
				</v-col>
				<v-col md="2" class="pt-0">
					<p class="sub-title-text-dark">{{$lang.TOTAL_AMOUNT}}</p>
					<p class="sub-title-text-dark secondary-text fs-13">{{trip_details.total_amount}}</p>
				</v-col>
				<v-col md="2" class="pt-0">
					<p class="sub-title-text-dark">{{$lang.RETURNS}}</p>
					<p class="sub-title-text-dark secondary-text fs-13">{{trip_details.return_shipment_count}}</p>
				</v-col>
				<v-col md="3" class="pt-0">
					<p class="sub-title-text-dark">{{$lang.RECEIVED_BY}}</p>
					<p class="sub-title-text-dark secondary-text fs-13">{{trip_details.received_by}}</p>
				</v-col>
			</v-row>
		</div>
		<!-- returned shipment list -->
		<div>
			<v-row class="">
				<v-col md="6" >
					<span class="page-title ">
						{{$lang.SHIPMENTS.toUpperCase()}} | {{shipment_list.length}}
					</span>
				</v-col>
			</v-row>
			<!-- show-select -->

			<v-data-table
			:headers="headers"
			:items="shipment_list"
			:hide-default-footer="true"
			:disable-sort="true"
			class="elevation-1 custome-header-bg custome-table-body"
			:loading="table_loading"
			>

			<template v-slot:item.action="{ item }">
				<v-btn small fab text @click="$router.push({name:'shipment-details',params:{shipment_id:encript(item.shipment_id)}})">	
					<img src="../../assets/arrow-right.svg" alt="">	
				</v-btn>	
			</template>
			<template v-slot:item.shipment_amount="{ item }">
				<span  v-if="item.type=='Collection'">{{item.shipment_amount}} </span>
				<span  v-else> 0.00</span>
			</template>	
			<template v-slot:item.type="{ item }">
				<span :class="item.type.toLowerCase()">
					{{item.type}}
				</span>
			</template>	
		</v-data-table>
	</div>
</div>
</template>
<script type="text/javascript">
export default {
	data(){
		return{

			transaction_id:"",
			trip_details:{
				amount:"",
				received_on:"",
				recipient_name:"",
				shipment_count:"",
				transaction_id:"",
				transaction_otp:"",
			},

			shipment_list:[],
			table_loading:false,
			headers: [
			{
				text: 'Shipment ID',
				align: 'start',
				sortable: false,
				value: 'shipment_id',
			},
			{ text: 'Retailer Info', value: 'retailer_firm_name' },
			{ text: 'Packages', value: 'number_of_packets' },
			{ text: 'Location', value: 'location' },
			{ text: 'Amount', value: 'shipment_amount' },
			{ text: 'Type', value: "type" },
			{ text: '', value: 'action' },
			],
		}
	},
	created(){
		this.$store.dispatch('drawer/setActiveTab',"collection")


		if (this.$route.params.transaction_id){
			this.transaction_id= this.decrypt(this.$route.params.transaction_id)
			this.getTripDetails()
		}
	},
	methods:{
		/* Fetching trip details form API*/ 
		getTripDetails() {
			const self=this
			let params={
				id:this.transaction_id,
			};
			self.table_loading=true

			const successHandler = (response) => {
				if (response.data.success){
					console.log(response)
					self.trip_details=response.data
					self.trip_details.return_shipment_count=response.data.return_list.length
					self.trip_details.total_package=parseInt(response.data.return_list.length)+parseInt(response.data.collection_list.length)

					let collection_list=response.data.collection_list
					let return_list=response.data.return_list
					/* adding extra keys for the  for collection  and Returns */
					collection_list.map(function(entry) {
						entry.type = 'Collection'//this.$keys.SHIPMENT_COLLECTION;
						return entry;
					});
					return_list.map(function(entry) {
						entry.type = "Returns"//this.$keys.SHIPMENT_RETURNS;
						return entry;
					});

					self.shipment_list=collection_list.concat(return_list)
				}
			};
			const finallyHandler = () => {
				self.table_loading=false
				this.$store.dispatch('setPageLoader', false)
			};

			self.request_GET( self,self.$urls.DEPOSIT_DETAILS,params,successHandler,null,null,finallyHandler)
		},

	}
}
</script>